import { render, staticRenderFns } from "./FormPickupPoints.vue?vue&type=template&id=7adb594b&"
import script from "./FormPickupPoints.vue?vue&type=script&lang=js&"
export * from "./FormPickupPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports